
import { useState } from 'react';

const faqs = [
  {
    category: '주문/배송',
    items: [
      {
        q: '주문 후 배송까지 얼마나 걸리나요?',
        a: '주문 확인 후 영업일 기준 1~2일 내 출고되며, 출고 후 1~2일 내 수령 가능합니다. 도서산간 지역은 추가 1~2일이 소요될 수 있습니다.',
      },
      {
        q: '배송비는 얼마인가요?',
        a: '3만원 이상 구매 시 무료배송이며, 3만원 미만 구매 시 배송비 3,000원이 부과됩니다.',
      },
      {
        q: '주문 취소는 어떻게 하나요?',
        a: '출고 전까지는 고객센터(02-3487-2025) 또는 이메일(homedr365@gmail.com)로 연락 주시면 취소 처리해 드립니다. 출고 이후에는 반품 절차로 진행됩니다.',
      },
    ],
  },
  {
    category: '제품/성분',
    items: [
      {
        q: '약손콩은 어떤 제품인가요?',
        a: '약손콩은 국내산 서리태(검은콩)를 주원료로 하여 스피루리나, 클로렐라 등 천연 성분을 배합한 건강기능식품입니다. 단백질, 식이섬유, 항산화 성분이 풍부합니다.',
      },
      {
        q: '하루 권장 섭취량은 얼마인가요?',
        a: '성인 기준 하루 2~3회, 1회 1포(10g)를 물 또는 음료에 타서 드시는 것을 권장합니다. 개인 건강 상태에 따라 조절하실 수 있습니다.',
      },
      {
        q: '알레르기 성분이 있나요?',
        a: '대두(콩) 성분이 포함되어 있습니다. 콩 알레르기가 있으신 분은 섭취 전 전문의와 상담하시기 바랍니다. 자세한 성분 정보는 제품 라벨을 확인해 주세요.',
      },
    ],
  },
  {
    category: '교환/반품',
    items: [
      {
        q: '교환 및 반품 기간은 얼마나 되나요?',
        a: '수령일로부터 7일 이내에 교환 및 반품 신청이 가능합니다. 단, 식품 특성상 개봉 후에는 교환/반품이 불가합니다.',
      },
      {
        q: '불량품을 받았을 때는 어떻게 하나요?',
        a: '불량품 수령 시 사진과 함께 고객센터로 연락 주시면 신속하게 교환 또는 환불 처리해 드립니다. 이 경우 반품 배송비는 저희가 부담합니다.',
      },
    ],
  },
  {
    category: '결제/혜택',
    items: [
      {
        q: '어떤 결제 수단을 사용할 수 있나요?',
        a: '신용카드, 체크카드, 계좌이체, 카카오페이, 네이버페이 등 다양한 결제 수단을 지원합니다.',
      },
      {
        q: '정기구독 할인이 있나요?',
        a: '정기구독 신청 시 매월 15% 할인 혜택을 드립니다. 구독 주기는 1개월, 2개월, 3개월 중 선택 가능하며 언제든지 변경/해지하실 수 있습니다.',
      },
    ],
  },
];

export default function FAQSection() {
  const [activeCategory, setActiveCategory] = useState('주문/배송');
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const currentFaqs = faqs.find((f) => f.category === activeCategory)?.items || [];

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-emerald-50 text-emerald-700 text-xs font-semibold rounded-full mb-4 tracking-wide">
            FAQ
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-gray-900 mb-3"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            자주 묻는 질문
          </h2>
          <p className="text-gray-500 text-sm md:text-base">
            궁금하신 점을 빠르게 확인해 보세요
          </p>
        </div>

        {/* Category Tabs */}
        <div className="flex flex-wrap gap-2 justify-center mb-8">
          {faqs.map((f) => (
            <button
              key={f.category}
              onClick={() => { setActiveCategory(f.category); setOpenIndex(null); }}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === f.category
                  ? 'bg-emerald-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-emerald-50 hover:text-emerald-700'
              }`}
            >
              {f.category}
            </button>
          ))}
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {currentFaqs.map((item, idx) => (
            <div
              key={idx}
              className="border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-4 text-left bg-white hover:bg-emerald-50/40 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-gray-800 pr-4">
                  <strong className="text-emerald-600 mr-2">Q.</strong>
                  {item.q}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-gray-400 text-lg"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 py-4 bg-emerald-50/30 border-t border-gray-100">
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                    <strong className="text-emerald-600 mr-2">A.</strong>
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
